import { OwnerOutput } from 'gql/types';

import { EditProfileFormSchemaType } from './schema';

export const getDefaultParamsOwner = (
  owner?: Partial<OwnerOutput>
): EditProfileFormSchemaType => {
  const contact = owner?.contacts?.[0];

  return {
    personalInfo: {
      firstName: owner?.firstName ?? '',
      lastName: owner?.lastName ?? '',
      phoneNumber: owner?.phoneNumber ?? '',
      streetAddress: owner?.streetAddress ?? '',
      city: owner?.city ?? '',
      state: owner?.state ?? '',
      zipCode: owner?.zipCode ?? '',
      locationPreferences: owner?.locationPreferences ?? '',
      birthday: owner?.birthday ? new Date(owner?.birthday) : undefined,
      contactPreferences: owner?.contactPreferences ?? undefined,
    },
    contact: {
      firstName: contact?.firstName ?? '',
      lastName: contact?.lastName ?? '',
      email: contact?.email ?? '',
      streetAddress: contact?.streetAddress ?? '',
      city: contact?.city ?? '',
      state: contact?.state ?? '',
      zipCode: contact?.zipCode ?? '',
      phoneNumber: contact?.phoneNumber ?? '',
    },
  };
};
